const AutoSelectDropDownValue = (DropDown) => {
    if (DropDown.length > 0) {
        if ( DropDown.length === 2) {
            return DropDown[1];
        }
    }
    return {value: "", display: ""}; // Return a default value if no match is found
};

export default AutoSelectDropDownValue;